import { useStagedJobsStore } from '@/stores/useStagedJobs';
import useIsUserManageOnly from '@/composables/useIsUserManageOnly';
import { hasMagicLinkToken } from '~/utilities/authTokens';

export default defineNuxtRouteMiddleware(async (to) => {
  const { isUserManageOnly } = useIsUserManageOnly();

  // Avoid calling staging if the user is manage only or if user is not fully authenticated
  if (isUserManageOnly || !hasMagicLinkToken()) {
    return;
  }

  const stagedJobsStore = useStagedJobsStore();
  const totalElements = stagedJobsStore.pagination.totalElements;

  if (totalElements === 0 && to.fullPath !== '/staged' && to.fullPath !== '/manage-jobs') {
    await stagedJobsStore.getStagedJobs();
  }
});
